import React, { useContext } from 'react';
import { number, string, bool } from 'prop-types';
import pathfinder from '@fiverr-private/pathfinder';
import { I18n } from '@fiverr-private/i18n-react';
import { EventTypes } from '../../../../../../../../../shared/utils/events/types';
import eventsReporter from '../../../../../../../../../shared/utils/events/reporter';
import { ROLLOUTS } from '../../../../../../../shared/constants/rollouts';
import SharedContext from '../../../../../../../../../shared/context';
import Rating from './Rating';
import { Badge } from './Badge';

import './style.scss';

const { sellerCard } = EventTypes.collectionPage;

const Headline = ({ username, rating, ratingCount, sellerLevel, isUnavailable = false }) => {
    const { rollouts } = useContext(SharedContext);
    const { [ROLLOUTS.QUALAS_NEW_LEVEL_SYSTEM]: inNewLevelSystem } = rollouts;
    const contactSellerUrl = pathfinder('conversation', { id: username });
    const showRating = Boolean(rating && ratingCount);
    const showContactSeller = !isUnavailable;

    const onContactSellerClick = () => {
        eventsReporter.report(sellerCard.contact.clicked);
    };

    return (
        <div className="headline tbody-6">
            <section className="main">
                <b>{username}</b>
                {showRating && <Rating rating={rating} ratingCount={ratingCount} />}
            </section>
            {inNewLevelSystem && <Badge sellerLevel={sellerLevel} />}
            {showContactSeller && (
                <a href={contactSellerUrl} onClick={onContactSellerClick}>
                    <I18n k="collections_perseus.collection_page.seller_card.contact_seller" />
                </a>
            )}
        </div>
    );
};

Headline.propTypes = {
    username: string,
    rating: number,
    ratingCount: number,
    isUnavailable: bool,
    sellerLevel: string,
};

export default Headline;
